import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Search, Heart, Sun } from 'lucide-react';
export function MethodAER() {
  const steps = [{
    letter: 'A',
    title: 'AUTOCUNOAȘTERE',
    text: 'Îți descoperi stilul de personalitate prin raportul DISC. Afli de ce reacționezi așa cum reacționezi și ce te declanșează. Te vezi clar, fără filtre.',
    icon: <Search className="w-6 h-6" strokeWidth={1.5} data-id="element-238" />
  }, {
    letter: 'E',
    title: 'EMOȚII REGLATE',
    text: 'Îți descoperi tiparele emoționale, mentale și comportamentale care te mențin reactiv. Le vezi clar, înțelegi de unde vin și începi să le echilibrezi, pas cu pas.',
    icon: <Heart className="w-6 h-6" strokeWidth={1.5} data-id="element-239" />
  }, {
    letter: 'R',
    title: 'RĂSPUNS CONȘTIENT & REDESCOPERIREA AUTENTICITĂȚII',
    text: 'Dezamorsezi butoanele reactive. Răspunzi calm și ferm, nu reacționezi impulsiv. Ai instrumente pentru conversații dificile și știi cum să creezi apropiere, nu distanță.',
    icon: <Sun className="w-6 h-6" strokeWidth={1.5} data-id="element-240" />
  }];
  const pathColors = ['border-plum/40', 'border-plum/60', 'border-orange/50'];
  const badgeBg = ['bg-plum', 'bg-plum-light', 'bg-gradient-to-br from-plum-light to-orange'];
  return <section className="bg-cream py-12 md:py-20 relative overflow-hidden" data-id="element-241">
      <div className="absolute bottom-0 right-0 w-full h-full bg-gradient-to-tl from-plum/5 to-transparent pointer-events-none" data-id="element-242"></div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-243">
        <FadeIn data-id="element-244">
          <div className="text-center max-w-[720px] mx-auto mb-12 md:mb-16" data-id="element-245">
            <h2 className="text-[32px] md:text-[48px] font-medium leading-[1.15] mb-6" data-id="element-246">
              Metoda A.E.R. pentru Relații Armonioase
            </h2>
            <p className="text-[17px] md:text-[19px] text-plum-light leading-[1.65]" data-id="element-247">
              Un proces simplu cu trei piloni. Îți cunoști stilul, înțelegi
              dinamica relațională și înveți să răspunzi calm și ferm, nu să
              reacționezi impulsiv.
            </p>
          </div>
        </FadeIn>

        {/* Vertical Roadmap */}
        <div className="max-w-[900px] mx-auto relative" data-id="element-248">
          {/* The vertical road/path - visible thick line */}
          <div className="absolute left-8 md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-1 z-0" data-id="element-249">
            <div className="w-full h-full bg-gradient-to-b from-plum/30 via-plum/50 to-orange/40 rounded-full" data-id="element-250"></div>
          </div>

          {/* Steps */}
          <div className="space-y-12 md:space-y-0 relative z-10" data-id="element-251">
            {steps.map((step, index) => {
            const isEven = index % 2 === 0;
            return <FadeIn key={index} delay={0.1 + index * 0.15} data-id="element-252">
                  <div className={`relative flex items-start gap-6 md:gap-0 ${index > 0 ? 'md:mt-[-20px]' : ''}`} data-id="element-253">
                    {/* Mobile: Badge on left */}
                    <div className="md:hidden relative z-20 shrink-0" data-id="element-254">
                      <div className={`w-16 h-16 rounded-full ${badgeBg[index]} flex items-center justify-center shadow-card-hover border-4 border-cream`} data-id="element-255">
                        <span className="font-fraunces font-semibold text-2xl text-cream" data-id="element-256">
                          {step.letter}
                        </span>
                      </div>
                    </div>

                    {/* Desktop: Zigzag layout */}
                    <div className="hidden md:grid md:grid-cols-[1fr_80px_1fr] w-full items-center" data-id="element-257">
                      {/* Left content (shows on even steps) */}
                      <div className={`${isEven ? 'pr-8' : ''}`} data-id="element-258">
                        {isEven && <div className="bg-cream-alt border border-plum-border rounded-[16px] p-8 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 ml-auto max-w-[380px]" data-id="element-259">
                            <div className="flex items-center gap-3 mb-4" data-id="element-260">
                              <div className="w-10 h-10 rounded-full bg-plum/10 flex items-center justify-center text-plum" data-id="element-261">
                                {step.icon}
                              </div>
                              <h3 className="text-[18px] md:text-[20px] font-semibold text-plum" data-id="element-262">
                                {step.title}
                              </h3>
                            </div>
                            <p className="text-[15px] md:text-[16px] text-plum-light leading-[1.65]" data-id="element-263">
                              {step.text}
                            </p>
                          </div>}
                      </div>

                      {/* Center: Badge on the road */}
                      <div className="flex justify-center relative z-20" data-id="element-264">
                        <div className={`w-[72px] h-[72px] rounded-full ${badgeBg[index]} flex items-center justify-center shadow-card-hover border-4 border-cream`} data-id="element-265">
                          <span className="font-fraunces font-semibold text-3xl text-cream" data-id="element-266">
                            {step.letter}
                          </span>
                        </div>
                      </div>

                      {/* Right content (shows on odd steps) */}
                      <div className={`${!isEven ? 'pl-8' : ''}`} data-id="element-267">
                        {!isEven && <div className="bg-cream-alt border border-plum-border rounded-[16px] p-8 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 mr-auto max-w-[380px]" data-id="element-268">
                            <div className="flex items-center gap-3 mb-4" data-id="element-269">
                              <div className="w-10 h-10 rounded-full bg-plum/10 flex items-center justify-center text-plum" data-id="element-270">
                                {step.icon}
                              </div>
                              <h3 className="text-[18px] md:text-[20px] font-semibold text-plum" data-id="element-271">
                                {step.title}
                              </h3>
                            </div>
                            <p className="text-[15px] md:text-[16px] text-plum-light leading-[1.65]" data-id="element-272">
                              {step.text}
                            </p>
                          </div>}
                      </div>
                    </div>

                    {/* Mobile: Content card */}
                    <div className="md:hidden flex-1" data-id="element-273">
                      <div className="bg-cream-alt border border-plum-border rounded-[16px] p-6 shadow-card" data-id="element-274">
                        <div className="flex items-center gap-3 mb-3" data-id="element-275">
                          <div className="w-8 h-8 rounded-full bg-plum/10 flex items-center justify-center text-plum" data-id="element-276">
                            {step.icon}
                          </div>
                          <h3 className="text-[17px] font-semibold text-plum" data-id="element-277">
                            {step.title}
                          </h3>
                        </div>
                        <p className="text-[15px] text-plum-light leading-[1.65]" data-id="element-278">
                          {step.text}
                        </p>
                      </div>
                    </div>
                  </div>
                </FadeIn>;
          })}
          </div>

          {/* Destination: Flame at the bottom */}
          <FadeIn delay={0.6} data-id="element-279">
            <div className="flex justify-start md:justify-center mt-10 relative z-20" data-id="element-280">
              <div className="ml-2 md:ml-0 w-20 h-20 rounded-full bg-gradient-to-br from-orange to-amber flex items-center justify-center shadow-btn-orange border-4 border-cream" data-id="element-281">
                <svg className="w-9 h-9 text-white" viewBox="0 0 100 100" fill="currentColor" data-id="element-282">
                  <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-283" />
                </svg>
              </div>
            </div>
            <p className="text-center mt-4 font-poppins font-semibold text-[14px] text-plum/60 uppercase tracking-wider" data-id="element-284">
              Relații Armonioase
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}